import { useEffect, useState, useRef } from "react";
import { words } from '../data/words'
import _ from 'lodash'
import { ChevronLeftIcon } from '@heroicons/react/solid'
import { useNavigate } from "react-router-dom";
import Alert from '../components/Alert'
import Modal from '../components/Modal'
import useSound from 'use-sound'
import succesSound from '../sounds/success.mp3'
import errorSound from '../sounds/error.mp3'
import winSound from '../sounds/win.mp3'
import overSound from '../sounds/over.mp3'
import Clock from '../components/Clock'

export default function SingleplayerGame(props) {

  const [gameData, setGameData] = useState([])
  const [userCurrentWord, setUserCurrentWord] = useState('')
  const [userPoints, setUserPoints] = useState(0)
  const [pcPoints, setPcPoints] = useState(0)
  const [infoMessage, setInfoMessage] = useState('')
  const [placeholderMessage, setPlaceholderMessage] = useState('')
  const [alertMessage, setAlertMessage] = useState('')
  const [alertVisible, setAlertVisible] = useState(false)
  const [activePlayer, setActivePlayer] = useState('user')
  const [wordList, setWordList] = useState([])
  const inputRef = useRef()
  const { timeLimit, scoreLimit, checkWordList, autoFillFirstLetter } = props.gameSettings
  const navigate = useNavigate();
  const [disableInput, setDisableInput] = useState(false)
  const [playSuccessSound] = useSound(succesSound)
  const [playErrorSound] = useSound(errorSound)
  const [playWinSound] = useSound(winSound)
  const [playOverSound] = useSound(overSound)
  const [modalData, setModalData] = useState({message: '', hidden: true, animation: ''})
  const [showClock, setShowClock] = useState(true)
  const [clockKey, setClockKey] = useState(0)



  useEffect(() => {
    setWordList(words)
  }, [])

  useEffect(() => {
    console.log(modalData)
    // eslint-disable-next-line
  }, [modalData])

  useEffect(() => {
    calculatePoints()
    generateInfoMessage()
    getStartingLetter()
    // eslint-disable-next-line
  }, [gameData])

  useEffect(() => {
    gameController()
    alertController()
    // eslint-disable-next-line
  }, [userPoints, pcPoints])


  function generateInfoMessage() {
    if (gameData.length === 0) {
      setInfoMessage('Write your first word')
      setPlaceholderMessage('Start the game by typing the first word')
    }

    if (gameData.length > 0 && gameData[0].user === 'pc') {
      // messages on user turn
      setInfoMessage('Your turn!')

      if (autoFillFirstLetter) {
        setUserCurrentWord(getStartingLetter())
      } else {
        setPlaceholderMessage(`Word should start with ${getStartingLetter()}`)
      }
    }

    if (gameData.length > 0 && gameData[0].user === 'user') {
      // messages on pc turn
      setInfoMessage('Pc is typing...')
      setPlaceholderMessage('')
    }

  }

  function getStartingLetter() {
    if (gameData.length > 0 && gameData[0].user === 'pc') {
      return gameData[0].word.charAt(gameData[0].word.length - 1)
    }
    return ''
  }

  function alertController() {
    if (gameData.length > 0 && gameData[0].user === 'user' && activePlayer === 'pc') {
      // messages on pc turn
      if (userPoints < scoreLimit) {
        setAlertMessage('Pc is typing...')
        setAlertVisible(true)
      }
    } else {
      setAlertMessage('')
      setAlertVisible(false)
    }

  }

  function handleUserWord(e) {
    let usedWords = []
    usedWords = gameData.map((item) => item.word)


    if (e.charCode === 13) {

      e.preventDefault()
      if (!userCurrentWord.toLowerCase().match(/^[A-Za-z]+$/)) {
        setInfoMessage('Only words with letters allowed!')
        setUserCurrentWord('')
        playErrorSound()
        return
      }

      if (userCurrentWord.toLowerCase().length < 3) {
        setInfoMessage('Word too short!')
        setUserCurrentWord('')
        playErrorSound()
        return
      }

      if (usedWords.includes(userCurrentWord.toLowerCase())) {
        setInfoMessage('Duplicate word!')
        setUserCurrentWord('')
        playErrorSound()
        return
      }

      if (usedWords.length > 0) {
        if (userCurrentWord.charAt(0) !== (usedWords[0].charAt(usedWords[0].length - 1))) {
          setInfoMessage('Starting with wrong letter!')
          setUserCurrentWord('')
          playErrorSound()
          return
        }
      }

      if (checkWordList) {
        if (!wordList.includes(userCurrentWord.toLowerCase())) {
          setInfoMessage('Not in word list!')
          setUserCurrentWord('')
          playErrorSound()
          return
        }
        let wordListCopy = [...wordList]
        let newWordList = _.remove(wordListCopy, (w) => {
          return w !== userCurrentWord.toLowerCase()
        })
        setWordList(newWordList)

      }

      setGameData((gameData) => [{ user: "user", word: userCurrentWord.toLowerCase() }, ...gameData])
      setActivePlayer('pc')
      playSuccessSound()

    }

  }

  function gameController() {
    if (gameData.length && gameData[0].user === 'user') {
      if (userPoints < scoreLimit) {
        setShowClock(false)
        setActivePlayer('pc')
        handlePCWord()
        setUserCurrentWord('')
      } else {
        setInfoMessage('You are the winner!')
        setActivePlayer('user')
        setDisableInput(true)
        playWinSound()
        setModalData({message: 'Congralutaions!', hidden: false, animation: 'bounceIn'})
      }

    } else if (gameData.length && gameData[0].user === 'pc') {
      if (pcPoints < scoreLimit) {
        setActivePlayer('user')
        inputRef.current.focus()
      } else {
        setInfoMessage('Pc is the winner!')
        setActivePlayer('pc')
        setDisableInput(true)
        setShowClock(true)
        setClockKey((clockKey) => clockKey + 1)
        playOverSound()
        setModalData({message: 'Game Over!', hidden: false, animation: 'bounceIn'})
      }

    }


  }


  function handlePCWord() {

    setTimeout(() => {
      setGameData((gameData) => [{ user: 'pc', word: getWord(gameData) }, ...gameData])
      setActivePlayer('user')
      setShowClock(true)
      setClockKey((clockKey) => clockKey + 1)
    }, 2000)

  }

  function getWord(data) {
    let wordListCopy = [...wordList]
    let usedWords = data.map((item) => item.word)
    let wordsWithFirstLetter = wordList.filter((word) => word.charAt(0) === usedWords[0].charAt(usedWords[0].length - 1))
    let newRandomWord = _.without(wordsWithFirstLetter, ...usedWords)[0]

    let newWordList = _.remove(wordListCopy, (w) => {
      return w !== newRandomWord.toLowerCase()
    })

    setWordList(newWordList)


    if (!newRandomWord) {
      return '<NO WORD FOUND>'
    }
    return newRandomWord
  }

function onModalClose() {
  setModalData({message: '', hidden: true, animation: ''})
}



  function calculatePoints() {

    let userData = gameData.filter((data) => data.user === 'user')
    let tempUserPoints = userData.reduce((sum, record) => {
      return !record ? sum : sum + record.word.length
    }, 0)


    let pcData = gameData.filter((data) => data.user === 'pc')
    let tempPcPoints = pcData.reduce((sum, record) => {
      return !record ? sum : sum + record.word.length
    }, 0)

    setUserPoints(tempUserPoints)
    setPcPoints(tempPcPoints)

  }

  function restartGame() {
    setShowClock(true)
    setClockKey((clockKey) => clockKey + 1)
    setGameData([])
    setActivePlayer('user')
    setWordList(words)
    setUserCurrentWord('')
    inputRef.current.focus()
    setDisableInput(false)
  }


  function onCompleteClock() {
    setInfoMessage('Pc is the winner!')
    setActivePlayer('pc')
    setDisableInput(true)
    playOverSound()
    setModalData({message: 'Game Over!', hidden: false, animation: 'bounceIn'})
  }


  return (
    <div className="App container mx-auto">
      <div className="flex text-white text-center drop-shadow-md z-10">
        <div className="flex-1 bg-lime-500 p-1">
          <h3 className="text-xl font-semibold">Player 1</h3>
          <p className="text-sm font-semibold">{userPoints} POINTS</p>
        </div>
        <div className="flex-1 bg-sky-500 p-1">
          <h3 className="text-xl font-semibold">Player 2</h3>
          <p className="text-sm font-semibold">{pcPoints} POINTS</p>
        </div>
      </div>
      <div className="flex">
        <div className={`flex-1 ${activePlayer === 'user' ? 'bg-lime-500' : 'bg-sky-500'} p-1 relative`}>
          <ChevronLeftIcon onClick={() => navigate('/singleplayer/setup')} className="text-white h-6 w-6 cursor-pointer" /> <p className="text-white text-sm text-center m-1">{infoMessage}</p>
          <form action="#">
            <input ref={inputRef} autoFocus enterKeyHint="send" disabled={activePlayer === 'pc' || disableInput} onKeyPress={(e) => { handleUserWord(e) }} value={userCurrentWord.toLowerCase()} onChange={(e) => setUserCurrentWord(e.target.value)} autoComplete="off" className="placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300 rounded-md py-2 pl-2 pr-3 shadow-sm focus:outline-none
      focus:ring-sky-500 focus:ring-1 text-xl font-bold"
              placeholder={placeholderMessage}
              type="text"
              name="search" />
          </form>
          <div className="bg-white rounded-md mt-1 p-3 h-48 overflow-y-scroll">
            <ul className="list-none">
              {gameData.length > 0 && gameData.map((data, index) => {
                return (
                  <li key={index} className={`${data.user === 'user' ? 'text-lime-500' : 'text-sky-500'}`} >{data.word} <span className="float-right text-black">{data.word.length}</span></li>
                )
              })}
            </ul>
          </div>
          <Alert show={alertVisible} message={alertMessage} />
         {timeLimit !== 0 && showClock && <Clock key={clockKey} countdown={timeLimit} onComplete={() => onCompleteClock()} />}
        </div>
      </div>
      <Modal message={modalData.message} hidden={modalData.hidden} animation={modalData.animation} onModalClose={onModalClose} onRestartGame={restartGame}  />
    </div>
  )
}

